import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import MEDIA_TYPES from '../../consts/mediaType.const';
import AmbientAudio from './ambient';
import { getLanguageForKey } from 'utils/languageHelper';
import i18n from 'utils/i18next';

const Audio = (props) => {
  const {
    available,
    enabled,
    scene: { hotspots },
    setIsHaveSoundUrl,
  } = props;

  const currentLanguage = i18n.language;

  const { isOpenPopUp } = useSelector((state) => state);

  const [audioUrl, setAudioUrl] = useState([{ repeat: '', soundUrl: '' }]);
  // PR
  useEffect(() => {
    let aUrl = [];
    if (available && enabled && hotspots && !isOpenPopUp) {
      const hotspot = hotspots.filter(
        (h) => h.media && h.media.type === MEDIA_TYPES.AUDIO && h.media.soundUrl
      );
      const audioConfigs = hotspot.map((item) => ({
        repeat: item.configs ? JSON.parse(item.configs).audioRepeat : true,
        soundUrl: getLanguageForKey(item.media, 'soundUrl', currentLanguage),
      }));

      aUrl = hotspot ? audioConfigs : [{ repeat: '', soundUrl: '' }];
    }
    if (aUrl[0]?.soundUrl !== audioUrl[0]?.soundUrl) {
      setAudioUrl(aUrl);

      window.logMessage('audioUrl', aUrl);
    }
  }, [available, enabled, hotspots, audioUrl, isOpenPopUp, currentLanguage]);

  useEffect(() => {
    setIsHaveSoundUrl(audioUrl.length);
    // eslint-disable-next-line
  }, [audioUrl]);

  return <AmbientAudio audios={audioUrl} />;
};

const mapStateToProps = ({ audio: { enabled, available } }) => ({
  enabled,
  available,
});

export default connect(mapStateToProps)(Audio);
